import type { AccountOptionTab } from '../account-options';

export const ACCOUNT_TABS = [
  { value: 'profile', label: 'Profile' },
  { value: 'settings', label: 'Settings' },
] as const satisfies readonly { value: AccountOptionTab; label: string }[];

export type AccountTab = (typeof ACCOUNT_TABS)[number]['value'];

export const isAccountTab = (value: string): value is AccountTab => ACCOUNT_TABS.some((tab) => tab.value === value);

export const accountTabLabel = (tab: AccountTab) => ACCOUNT_TABS.find(({ value }) => value === tab)?.label ?? tab;
